export const endpoint = "https://qbmedia.b-cdn.net/qbmedia/"

export const bizDetails = {
    name: "Don Pizza | دون بيزا",
    description: "البيزا الي رح يعشقها قلبك",
    socialBtns : {
        menu: "المنيو",
        call: "اتصل",
        wsp: "واتساب",
        ig: "انستاغرام",
        fb: "فيسبوك",
        website: "الموقع",
        tiktok:"تيكتوك",
        mail: "مييل",
        app: "أُطلب",
        review: "قييمني",
        meeting: "عين موعد"
    },
    saveBtnText: "ضيفني لجهات الاتصال",
    orderNowText: "أطلب وجبتك الأن",
    feedback: {
        customerServiceRating: "تقييم خدمة العملاء",
        ratingCopied: "تم نسخ التقييم إلى الحافظة. الرجاء لصقها في تقييمات Google.",
        rateExperience: "هل اعجبتك خدماتنا؟ هل تنصح بنا؟ قييم تجربتك.",
        feedbackPlaceholder: "أدخل ملاحظاتك هنا...",
        submitRating: "إرسال التقييم",
        thankYouPositive: "شكرًا لك على ملاحظاتك الإيجابية! هل يمكنك أخذ لحظة لمشاركة تقييمك على صفحة أعمالنا على Google؟ سيساعدنا ذلك كثيراً",
        copyRating: "نسخ التقييم",
        completeGoogleReview: "اكمال التقييم في Google",
        thankYouImprovement: "شكرًا لك على ملاحظاتك ومصداقيتك معنا. سنعمل بجد على التطوير والتحسين من ذاتنا."
    },
    modals: {
        scheduleAppointment: "تعيين موعد اونلاين",
        rateUs: "قييمنا بناء على تعاملك معنا"
    }
}

export const bizDetails_He = {
    name: "Don Pizza | דון פיצה",
    description: "הפיצה שתאהוב מביס ראשון",
    socialBtns : {
        menu: "התפריט",
        call: "שיחה",
        wsp: "וואטספ",
        ig: "אינסטגרם",
        fb: "פייסבוק",
        website: "האתר",
        tiktok:"טיקטוק",
        mail: "מייל",
        app: "הזמן",
        review: "דרג אותנו",
        meeting: "פגישה"
    },
    saveBtnText: "הוסף אותנו לאנשי קשר",
    orderNowText: "הזמן שירות עכשיו",
    feedback: {
        customerServiceRating: "דירוג שירות לקוחות",
        ratingCopied: "הדירוג הועתק ללוח. אנא הדבק אותו בביקורות Google.",
        rateExperience: "האם אהבת את השירותים שלנו? האם היית ממליץ עלינו? דרג את החוויה שלך.",
        feedbackPlaceholder: "הכנס את המשוב שלך כאן...",
        submitRating: "שלח דירוג",
        thankYouPositive: "תודה על המשוב החיובי שלך! האם תוכל לקחת רגע לשתף את הדירוג שלך בדף העסק שלנו ב-Google? זה יעזור לנו מאוד",
        copyRating: "העתק דירוג",
        completeGoogleReview: "השלם דירוג ב-Google",
        thankYouImprovement: "תודה על המשוב והכנות שלך איתנו. אנחנו נעבוד קשה לפתח ולשפר את עצמנו."
    },
    modals: {
        scheduleAppointment: "קביעת פגישה אונליין",
        rateUs: "דרג אותנו בהתבסס על הניסיון שלך"
    }
}

export const bizDetails_En = {
    name: "Don Pizza",
    description: "Every pizza needs a don!",
    socialBtns : {
        menu: "Menu",
        call: "Call Us",
        wsp: "Txt Us",
        ig: "Our IG",
        fb: "Our FB",
        website: "Website",
        tiktok:"Tiktok",
        mail: "Mail",
        app: "order now",
        review: "Rate Us",
        meeting: "Meet Us"
    },
    saveBtnText: "Add Us To Contacts",
    orderNowText: "Order a Service",
    feedback: {
        customerServiceRating: "Customer Service Rating",
        ratingCopied: "Rating copied to clipboard. Please paste it in Google reviews.",
        rateExperience: "Did you like our services? Would you recommend us? Rate your experience.",
        feedbackPlaceholder: "Enter your feedback here...",
        submitRating: "Submit Rating",
        thankYouPositive: "Thank you for your positive feedback! Could you take a moment to share your rating on our Google business page? It would help us a lot",
        copyRating: "Copy Rating",
        completeGoogleReview: "Complete Google Review",
        thankYouImprovement: "Thank you for your feedback and honesty with us. We will work hard to develop and improve ourselves."
    },
    modals: {
        scheduleAppointment: "Schedule Online Appointment",
        rateUs: "Rate us based on your experience"
    }
}

export const contact = {
    name: "Don Pizza",
    phone: "972525511812",
    email: "info@donpizza.co.il",
    app: "info@donpizza.co.أطلب الآن",
    website: "https://donpizza.co.il/",
    ig:"donpizza.co.il",
    fb:"profile.php?id=donpizza",
    // menu:"https://menu.risto.co.il/",
    menu:"https://menu.donpizza.co.il",
    waze: "",
};

export const schedule = {
    link:"https://.com",
    title:"קביעת פגישה אונליין",
}

export const footer = {
    desclaimer: "برمجه وتصميم",
    copywrites: "كيوبي ميديا"
}

export const socialAccounts = {
    wsp:`https://api.whatsapp.com/send?phone=${contact.phone}`,
    ig:`http://instagram.com/${contact.ig}`,
    fb:`https://facebook.com/${contact.fb}`,
    app:`https://haat.delivery`,
}